import { PLAN_TIMEZONE } from "./limits.ts";

// America/Fortaleza has no daylight saving time; its offset is a constant UTC-03:00 (horário de Brasília).
export const PLAN_UTC_OFFSET = "-03:00";

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/** True for a real calendar date written as YYYY-MM-DD (rejects 2026-02-30). */
export function isIsoDate(value: string): boolean {
  const m = ISO_DATE.exec(value);
  if (!m) return false;
  const d = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  return d.getUTCFullYear() === Number(m[1]) && d.getUTCMonth() === Number(m[2]) - 1 && d.getUTCDate() === Number(m[3]);
}

/** Access ends at 23:59:59.999 of the chosen local date in the plan timezone (DEC defaults). */
export function endOfLocalDayUtc(isoDate: string): Date {
  return new Date(`${isoDate}T23:59:59.999${PLAN_UTC_OFFSET}`);
}

/** The local calendar date (plan timezone) of a UTC instant, as YYYY-MM-DD. */
export function localDateOf(instant: Date | string): string {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: PLAN_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(instant));
  return parts; // en-CA formats as YYYY-MM-DD
}

/** DD/MM/YYYY without going through Date (no UTC shift). */
export function formatDateBR(isoDate: string | null | undefined): string {
  if (!isoDate) return "";
  const m = ISO_DATE.exec(isoDate);
  return m ? `${m[3]}/${m[2]}/${m[1]}` : isoDate;
}

/** Timestamp shown in the plan timezone, e.g. 29/10/2026 14:05. */
export function formatInstantBR(instant: Date | string | null | undefined): string {
  if (!instant) return "";
  return new Intl.DateTimeFormat("pt-BR", {
    timeZone: PLAN_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(instant));
}

const MONTHS = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

/** Compact report date, as in the instructor's synthetic report: "2026-10-01" → "1.out.2026". */
export function formatDateShortBR(isoDate: string | null | undefined): string {
  const m = isoDate ? ISO_DATE.exec(isoDate) : null;
  if (!m) return "";
  return `${Number(m[3])}.${MONTHS[Number(m[2]) - 1]!.slice(0, 3)}.${m[1]}`;
}

/** "novembro / 2026" for an instant, in horário de Brasília. */
export function formatMonthYearBR(instant: Date | string): string {
  const [y, mo] = localDateOf(instant).split("-");
  return `${MONTHS[Number(mo) - 1]} / ${y}`;
}
